import React, { useEffect, useState, useCallback } from 'react'
import { Icon, Position } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import tooltipStyles from '../Activity/Tooltips.module.scss'
import { IssueTag } from '../Issue/Issue'
import styles from './RosterError.module.scss'
const RosterError = (props) => {
  const [open, setOpen] = useState(false)
  const x = props.xScale
  const d = props.data
  const onMouseEnter = useCallback(() => {
    if (!props.drag) setOpen(true)
  }, [props.drag])

  const style = React.useMemo(
    () => ({
      transform: `translateX(${x(d.startTime) + 2}px)`,
      width: x(d.endTime) - x(d.startTime) - 4,
    }),
    [x, d.startTime, d.endTime]
  )
  if (d.issueType === 'FlightCoverageIssue') return null
  return (
    <span
      onMouseEnter={onMouseEnter}
      onMouseLeave={() => setOpen(false)}
      className={styles.emptyRosterDay}
      style={style}>
      {open && (
        <Tooltip2
          usePortal={true}
          portalContainer={document.getElementById('main')}
          content={
            <div style={{ maxWidth: 300 }}>
              <IssueTag d={d} />
            </div>
          }
          autoFocus={false}
          placement={Position.BOTTOM}
          defaultIsOpen
          targetClassName={styles.tooltip}
          renderTarget={({ isOpen: isTooltipOpen, ...tooltipProps }) => (
            <div {...tooltipProps} style={{ width: x(d.endTime) - x(d.startTime) - 4 }} />
          )}
        />
      )}
    </span>
  )
}

export default React.memo(RosterError)
